export default __webpack_public_path__ + "static/media/1978.6064b430.jpg";